export default ({ data: { error } }) =>
  error && error.message && error.message.includes('AuthorizationError1');
